import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { listPrinters } from '../../services/qzPrinterService';
import { sortPrintersByHint } from '../../utils/labelPrinterMatch';
import { setSavedPrinterName } from '../../utils/labelPrinterStorage';
import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'PrinterSelectionModal';

/**
 * Modal to pick a Windows printer queue visible to QZ Tray.
 */
const PrinterSelectionModal = ({
  show,
  onHide,
  authToken,
  initialSelection = '',
  onSaved,
}) => {
  const [printers, setPrinters] = useState([]);
  const [selected, setSelected] = useState(initialSelection);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return undefined;
    setSelected(initialSelection || '');
    setError('');
    setLoading(true);
    (async () => {
      try {
        const found = await listPrinters(authToken);
        setPrinters(sortPrintersByHint(found));
      } catch (err) {
        setError(err.message || 'Could not list printers.');
        setPrinters([]);
      } finally {
        setLoading(false);
      }
    })();
    return undefined;
  }, [show, authToken, initialSelection]);

  const handleSave = () => {
    if (!selected) return;
    setSavedPrinterName(selected);
    logInfo(LOG_CONTEXT, 'printer saved', { selected });
    onSaved?.(selected);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select label printer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" role="status" />
          </div>
        ) : error ? (
          <p className="text-danger mb-0">{error}</p>
        ) : (
          <Form.Group>
            <Form.Label>Printer queue</Form.Label>
            <Form.Select
              value={selected}
              onChange={e => setSelected(e.target.value)}
            >
              <option value="">Choose a printer…</option>
              {printers.map(name => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={!selected || loading}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PrinterSelectionModal;
